import { SemanticDecisions } from '../../generator';
import * as ColorPalette from '../color';

import {
    CATEGORY_COLOR_DENIM_200,
    CATEGORY_COLOR_DENIM_50,
    CATEGORY_COLOR_DENIM_500,
    CATEGORY_COLOR_DENIM_900,
    CATEGORY_COLOR_LAVENDER_200,
    CATEGORY_COLOR_LAVENDER_50,
    CATEGORY_COLOR_LAVENDER_500,
    CATEGORY_COLOR_LAVENDER_900,
    CATEGORY_COLOR_LIME_200,
    CATEGORY_COLOR_LIME_50,
    CATEGORY_COLOR_LIME_500,
    CATEGORY_COLOR_LIME_900,
    CATEGORY_COLOR_MUSTARD_200,
    CATEGORY_COLOR_MUSTARD_50,
    CATEGORY_COLOR_MUSTARD_500,
    CATEGORY_COLOR_MUSTARD_900,
    CATEGORY_COLOR_RUBY_200,
    CATEGORY_COLOR_RUBY_50,
    CATEGORY_COLOR_RUBY_500,
    CATEGORY_COLOR_RUBY_900,
    CATEGORY_COLOR_TANGERINE_200,
    CATEGORY_COLOR_TANGERINE_50,
    CATEGORY_COLOR_TANGERINE_500,
    CATEGORY_COLOR_TANGERINE_900,
} from '../light/foundation/categoryColor';

export const DARK_SEMANTIC_DECISIONS: SemanticDecisions = {
    interactive: {
        basic: {
            default: ColorPalette.COLOR_GREY_700,
            hover: ColorPalette.COLOR_GREY_600,
            active: ColorPalette.COLOR_GREY_500,
            focus: 'red',
            disabled: 'red',
        },
        basicSecondary: {
            default: {
                default: ColorPalette.COLOR_GREY_600,
                hover: ColorPalette.COLOR_GREY_500,
                active: ColorPalette.COLOR_GREY_300,
                focus: 'red',
                disabled: 'red',
            },
            contrast: {
                default: ColorPalette.COLOR_GREY_600,
                hover: ColorPalette.COLOR_GREY_500,
                active: ColorPalette.COLOR_GREY_300,
                focus: 'red',
                disabled: 'red',
            },
        },
        primary: {
            default: ColorPalette.COLOR_INDIGO_300,
            hover: ColorPalette.COLOR_INDIGO_200,
            active: ColorPalette.COLOR_INDIGO_100,
            focus: 'red',
            disabled: ColorPalette.COLOR_INDIGO_500_32P,
        },
        info: {
            default: ColorPalette.COLOR_BLUE_500,
            hover: ColorPalette.COLOR_BLUE_600,
            active: ColorPalette.COLOR_BLUE_800,
            focus: 'red',
            disabled: ColorPalette.COLOR_BLUE_500_32P,
        },
        success: {
            default: ColorPalette.COLOR_GREEN_500,
            hover: ColorPalette.COLOR_GREEN_600,
            active: ColorPalette.COLOR_GREEN_800,
            focus: 'red',
            disabled: ColorPalette.COLOR_GREEN_500_32P,
        },
        warning: {
            default: ColorPalette.COLOR_YELLOW_500,
            hover: ColorPalette.COLOR_YELLOW_600,
            active: ColorPalette.COLOR_YELLOW_800,
            focus: 'red',
            disabled: ColorPalette.COLOR_YELLOW_500_32P,
        },
        destructive: {
            default: ColorPalette.COLOR_RED_500,
            hover: ColorPalette.COLOR_RED_600,
            active: ColorPalette.COLOR_RED_800,
            focus: 'yellow',
            disabled: ColorPalette.COLOR_RED_500_32P,
        },
        plain: {
            basic: {
                default: 'transparent',
                hover: ColorPalette.COLOR_GREY_700,
                active: ColorPalette.COLOR_GREY_600,
                focus: 'red',
                disabled: 'red',
            },
            contrast: {
                default: 'transparent',
                hover: ColorPalette.COLOR_GREY_0_32P,
                active: ColorPalette.COLOR_GREY_0_64P,
                focus: 'red',
                disabled: 'red',
            },
        },
        bold: {
            basic: {
                default: ColorPalette.COLOR_GREY_300,
                hover: ColorPalette.COLOR_GREY_200,
                active: ColorPalette.COLOR_GREY_100,
                focus: 'red',
                disabled: 'red',
            },
            contrast: {
                default: ColorPalette.COLOR_GREY_0,
                hover: ColorPalette.COLOR_GREY_200,
                active: ColorPalette.COLOR_GREY_300,
                focus: 'red',
                disabled: 'red',
            },
        },
    },
    backgroundColor: {
        body: {
            basic: ColorPalette.COLOR_GREY_1000,
        },
        surface: {
            basic: {
                default: ColorPalette.COLOR_GREY_1000,
                inverse: ColorPalette.COLOR_GREY_0,
            },
            thin: {
                default: ColorPalette.COLOR_GREY_700,
                contrast: ColorPalette.COLOR_GREY_1000,
            },
            extraLight: ColorPalette.COLOR_GREY_700,
            light: ColorPalette.COLOR_GREY_600,
            medium: {
                default: ColorPalette.COLOR_GREY_500,
                contrast: ColorPalette.COLOR_GREY_300,
            },
            emphasized: ColorPalette.COLOR_GREY_1100,
            highlighted: ColorPalette.COLOR_INDIGO_500_8P,
        },
        semantic: {
            basic: ColorPalette.COLOR_GREY_1000,
            primary: ColorPalette.COLOR_INDIGO_300,
            info: ColorPalette.COLOR_BLUE_500,
            success: ColorPalette.COLOR_GREEN_500,
            destructive: ColorPalette.COLOR_RED_500,
            warning: ColorPalette.COLOR_YELLOW_500,
        },
        semanticSubtle: {
            basic: ColorPalette.COLOR_GREY_200,
            primary: ColorPalette.COLOR_INDIGO_100,
            info: ColorPalette.COLOR_BLUE_100,
            success: ColorPalette.COLOR_GREEN_100,
            destructive: ColorPalette.COLOR_RED_100,
            warning: ColorPalette.COLOR_YELLOW_100,
        },
        semanticSubtleTransparent: {
            basic: ColorPalette.COLOR_GREY_500_32P,
            primary: ColorPalette.COLOR_INDIGO_500_16P,
            info: ColorPalette.COLOR_BLUE_500_16P,
            success: ColorPalette.COLOR_GREEN_500_16P,
            destructive: ColorPalette.COLOR_RED_500_16P,
            warning: ColorPalette.COLOR_YELLOW_500_16P,
        },
        semanticSecondarySubtleTransparent: {
            basic: ColorPalette.COLOR_GREY_500_32P,
            primary: ColorPalette.COLOR_INDIGO_300_32P,
            info: ColorPalette.COLOR_BLUE_500_32P,
            success: ColorPalette.COLOR_GREEN_500_32P,
            destructive: ColorPalette.COLOR_RED_500_32P,
            warning: ColorPalette.COLOR_YELLOW_500_32P,
        },
        onSemanticBackground: {
            light: {
                basic: ColorPalette.COLOR_GREY_1100,
                transparent: ColorPalette.COLOR_GREY_1000_32P,
            },
            dark: {
                basic: ColorPalette.COLOR_GREY_1100,
                transparent: ColorPalette.COLOR_GREY_1000_32P,
            },
        },
        contrast: {
            light: ColorPalette.COLOR_GREY_0,
            dark: ColorPalette.COLOR_GREY_1100,
        },
        category: {
            mustard: CATEGORY_COLOR_MUSTARD_500,
            tangerine: CATEGORY_COLOR_TANGERINE_500,
            lavender: CATEGORY_COLOR_LAVENDER_500,
            denim: CATEGORY_COLOR_DENIM_500,
            lime: CATEGORY_COLOR_LIME_500,
            ruby: CATEGORY_COLOR_RUBY_500,
        },
        categorySubtle: {
            mustard: CATEGORY_COLOR_MUSTARD_50,
            tangerine: CATEGORY_COLOR_TANGERINE_50,
            lavender: CATEGORY_COLOR_LAVENDER_50,
            denim: CATEGORY_COLOR_DENIM_50,
            lime: CATEGORY_COLOR_LIME_50,
            ruby: CATEGORY_COLOR_RUBY_50,
        },
        backdrop: ColorPalette.COLOR_GREY_1000_64P,
    },
    textColor: {
        font: {
            basic: {
                default: ColorPalette.COLOR_GREY_0,
                inverse: ColorPalette.COLOR_GREY_1100,
                contrast: ColorPalette.COLOR_GREY_0,
            },
            secondary: {
                default: ColorPalette.COLOR_GREY_0_64P,
                contrast: ColorPalette.COLOR_GREY_0_64P,
            },
            tertiary: {
                default: ColorPalette.COLOR_GREY_0_32P,
                contrast: ColorPalette.COLOR_GREY_0_32P,
            },
        },
        semantic: {
            basic: ColorPalette.COLOR_GREY_0_64P,
            primary: ColorPalette.COLOR_INDIGO_300,
            info: ColorPalette.COLOR_BLUE_500,
            success: ColorPalette.COLOR_GREEN_500,
            destructive: ColorPalette.COLOR_RED_500,
            warning: ColorPalette.COLOR_YELLOW_500,
        },
        semanticStrong: {
            basic: ColorPalette.COLOR_GREY_900,
            primary: ColorPalette.COLOR_INDIGO_600,
            info: ColorPalette.COLOR_BLUE_800,
            success: ColorPalette.COLOR_GREEN_800,
            destructive: ColorPalette.COLOR_RED_800,
            warning: ColorPalette.COLOR_YELLOW_800,
        },
        onSemanticBackground: {
            light: ColorPalette.COLOR_GREY_1100,
            dark: ColorPalette.COLOR_GREY_1100,
        },
        contrast: {
            light: ColorPalette.COLOR_GREY_0,
            dark: ColorPalette.COLOR_GREY_1100,
        },
        category: {
            mustard: CATEGORY_COLOR_MUSTARD_500,
            tangerine: CATEGORY_COLOR_TANGERINE_500,
            lavender: CATEGORY_COLOR_LAVENDER_500,
            denim: CATEGORY_COLOR_DENIM_500,
            lime: CATEGORY_COLOR_LIME_500,
            ruby: CATEGORY_COLOR_RUBY_500,
        },
        categoryStrong: {
            mustard: CATEGORY_COLOR_MUSTARD_900,
            tangerine: CATEGORY_COLOR_TANGERINE_900,
            lavender: CATEGORY_COLOR_LAVENDER_900,
            denim: CATEGORY_COLOR_DENIM_900,
            lime: CATEGORY_COLOR_LIME_900,
            ruby: CATEGORY_COLOR_RUBY_900,
        },
    },
    borderColor: {
        semantic: {
            basic: ColorPalette.COLOR_GREY_500,
            primary: ColorPalette.COLOR_INDIGO_300,
            info: ColorPalette.COLOR_BLUE_500,
            success: ColorPalette.COLOR_GREEN_500,
            destructive: ColorPalette.COLOR_RED_500,
            warning: ColorPalette.COLOR_YELLOW_500,
        },
        semanticSubtle: {
            basic: ColorPalette.COLOR_GREY_700,
            primary: ColorPalette.COLOR_INDIGO_100,
            info: ColorPalette.COLOR_BLUE_200,
            success: ColorPalette.COLOR_GREEN_200,
            destructive: ColorPalette.COLOR_RED_200,
            warning: ColorPalette.COLOR_YELLOW_200,
        },
        categorySubtle: {
            mustard: CATEGORY_COLOR_MUSTARD_200,
            tangerine: CATEGORY_COLOR_TANGERINE_200,
            lavender: CATEGORY_COLOR_LAVENDER_200,
            denim: CATEGORY_COLOR_DENIM_200,
            lime: CATEGORY_COLOR_LIME_200,
            ruby: CATEGORY_COLOR_RUBY_200,
        },
        interactive: {
            basic: {
                default: ColorPalette.COLOR_GREY_500,
                hover: ColorPalette.COLOR_GREY_400,
                active: ColorPalette.COLOR_GREY_300,
                focus: 'red',
                disabled: ColorPalette.COLOR_GREY_1000,
            },
        },
        image: {
            transparent: ColorPalette.COLOR_GREY_0_32P,
        },
        divider: {
            basic: ColorPalette.COLOR_GREY_500,
        },
        container: ColorPalette.COLOR_GREY_500_16P,
    },
};
